<template>
    <SurveyLayout class="override" :progressStep="1" :questionId="1" nextPageId="SurveyPage03">
        <template #card-title>Round Duration</template>
        <template #question>How do you prefer round timing to be set?</template>
        
        <template #choice-a>4 min Voting + 1 min Auction</template>
        <template #choice-b>3 min Voting + 2 min Auction</template>
        <template #choice-c>2 min Voting + 3 min Auction</template>

        <template #tip-a>Vote for longer voting if you prefer <span class="prominent">more lucky draws</span></template>
        <template #tip-b>Vote for longer auctions if you prefer to have more chance for securing your position through bidding</template>

        <template #help-title>Round Duration</template>
        <template #help-content>
            <p>Each round is concluded in about 5 minutes. However, it’s up to you to decide how it should split between voting and auction.</p>
        </template>
    </SurveyLayout>
</template>

<style lang="scss" scoped>
@use '@/assets/css/_tools' as *;

.override {
    --img-override-size: 146px;

    @include responsive-field-x4(--img-override, '@/assets/imgs/rounds/time-limit.png');    
}

</style>